export enum Protocol {
  EGTS,
  Teltonika,
  WialonIPS,
  WialonRetranslator
}
